import { useTranslation } from 'react-i18next';
import { SystemIcon } from '@monorepo/nova-icons';
import { useBreakpoints, useTheme } from '@monorepo/nova-ui';
import { StyledCloseIconButton } from '../styled';

interface CloseIconProps {
  onClick: () => void;
}

export const CloseIcon = ({ onClick }: CloseIconProps) => {
  const theme = useTheme();
  const { isMobileOrTablet } = useBreakpoints();
  const { t } = useTranslation('common');

  return (
    <StyledCloseIconButton
      onClick={onClick}
      aria-label={t('close')}
      size="small"
    >
      <SystemIcon
        iconName="X"
        size={isMobileOrTablet ? 16 : 24}
        color={theme.palette.secondaryInvert.main}
      />
    </StyledCloseIconButton>
  );
};
